export interface ArticleItem {
  id: number;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  author: string;
  authorAvatar?: string;
  date: string;
  readTime: string;
  image: string;
  tags?: string[];
}

export const allArticles: ArticleItem[] = [
  {
    id: 1,
    title: "如何在交友平台上展现真实的自己",
    excerpt: "展示真实的自己，是建立真诚关系的第一步。本文分享如何在交友平台上自然展现个性，同时保持必要的隐私保护。",
    content: `在这个数字化的时代，交友平台已经成为许多人结识新朋友的重要渠道。然而，如何在虚拟空间中展现真实、立体的自己，同时保护好个人隐私，是许多人面临的困惑。

<h3>一、从真诚出发</h3>
<p>真诚是建立任何关系的基础。在网络交友中，真诚意味着你展示的信息是真实的，你的表达是发自内心的。不必刻意迎合他人的期待，做真实的自己才能吸引到真正欣赏你的人。</p>

<h3>二、个人资料的撰写技巧</h3>
<p>个人资料是别人了解你的第一窗口。建议从以下几个方面入手：首先，选择3-5个最能代表你的关键词；其次，用生动的语言描述你的兴趣爱好，而不是简单罗列；最后，分享一些有趣的小故事或经历，让他人更容易产生共鸣。</p>

<h3>三、照片选择的学问</h3>
<p>照片是展示个人形象的重要方式。建议选择自然光线下的生活照，避免过度修图。可以展示你的兴趣爱好，如旅行、运动、阅读等场景。记住，真实的笑容比完美的角度更有感染力。</p>

<h3>四、保护隐私的边界意识</h3>
<p>在展示真实自我的同时，务必保护好自己的隐私。不要公开分享家庭住址、工作单位、银行卡号等敏感信息。可以选择在建立一定信任后，逐步分享更多个人信息。</p>

<h3>五、开启有深度的对话</h3>
<p>与其停留在"你好"、"在干嘛"的表面寒暄，不如从对方的资料中找到共同话题。提出开放性问题，认真倾听对方的回答，分享自己的真实感受，这样才能建立有意义的对话。</p>`,
    category: "dating-tips",
    categoryName: "交友技巧",
    author: "小雨",
    date: "2026-08-08",
    readTime: "8分钟",
    image: "https://readdy.ai/api/search-image?query=Warm%20minimalist%20desk%20scene%20with%20laptop%20and%20notebook%2C%20soft%20natural%20lighting%2C%20cozy%20modern%20interior%20with%20indoor%20plants%2C%20editorial%20lifestyle%20photography%2C%20calm%20and%20introspective%20mood%2C%20gentle%20beige%20and%20cream%20tones%2C%20clean%20composition%20without%20people&width=800&height=500&seq=article-feat-1&orientation=landscape",
    tags: ["交友技巧", "个人展示", "隐私保护", "社交指南"]
  },
  {
    id: 2,
    title: "2026年同志骄傲月活动全攻略",
    excerpt: "一年一度的骄傲月即将到来，全国各大城市将举办丰富多彩的庆祝活动。这份攻略带你了解各地活动安排与参与方式。",
    content: `骄傲月是全球LGBTQ+社群最重要的节日之一。每年的六月，世界各地都会举办丰富多彩的庆祝活动。以下是2026年骄傲月的活动全攻略。

<h3>一、骄傲月的由来与意义</h3>
<p>骄傲月的起源可以追溯到1969年的石墙运动。如今，骄傲月已经超越了纪念的意义，成为了庆祝多样性、倡导平等权利、展现社群力量的全球盛事。</p>

<h3>二、各地主要活动一览</h3>
<p>今年，北京、上海、广州、成都、深圳等城市都将举办相关活动。包括骄傲跑、艺术展览、电影放映、文化讲座、社群聚会等多种形式。部分活动详情可在男同网活动板块查看。</p>

<h3>三、如何安全参与活动</h3>
<p>参与线下活动时，请注意以下几点：选择可信赖的组织方举办的活动；与朋友结伴前往；注意个人隐私保护；如需拍照，请征得他人同意；遵守活动现场的各项规则。</p>

<h3>四、线上庆祝方式</h3>
<p>如果你不方便参与线下活动，也可以通过线上方式庆祝。男同网将举办线上话题讨论、直播分享等系列活动，让你足不出户也能感受节日氛围。</p>

<h3>五、骄傲月的精神延续</h3>
<p>骄傲不只在六月。让我们将骄傲月的精神延续到日常生活的每一天——勇敢做自己，友善待他人，为构建更加包容的社会贡献一份力量。</p>`,
    category: "community-events",
    categoryName: "社区活动",
    author: "阿杰",
    date: "2026-08-05",
    readTime: "12分钟",
    image: "https://readdy.ai/api/search-image?query=Colorful%20festival%20atmosphere%20with%20warm%20decorative%20lights%20and%20celebration%20elements%2C%20soft%20evening%20ambient%20lighting%2C%20vibrant%20yet%20elegant%20party%20scene%2C%20artistic%20photography%20with%20shallow%20depth%20of%20field%2C%20warm%20golden%20and%20rose%20tones%2C%20no%20people%20visible&width=800&height=500&seq=article-feat-2&orientation=landscape",
    tags: ["骄傲月", "社区活动", "LGBTQ+", "活动攻略"]
  },
  {
    id: 3,
    title: "出柜后的心理调适：过来人的经验分享",
    excerpt: "出柜是重要的人生决定，之后的心理调适同样关键。多位过来人分享他们的心路历程和实用建议。",
    content: `出柜是每个同志人生中的重要时刻。但出柜之后，如何调适自己的心理状态，面对可能出现的各种反应，同样是一个需要认真对待的课题。

<h3>一、给自己足够的时间</h3>
<p>不要期待出柜后一切立即变得完美。无论是你自己的心理状态，还是周围人的反应，都需要时间来调整和适应。给自己和他人足够的时间和空间。</p>

<h3>二、建立支持系统</h3>
<p>一个强大的支持系统对于心理健康至关重要。这包括理解你的家人、支持你的朋友、专业的心理咨询师，以及像男同网这样的社群平台。你不需要独自面对一切。</p>

<h3>三、处理负面反应</h3>
<p>并不是每个人都能立即理解和接受。面对负面反应时，保持冷静和自信是关键。记住，他人的不理解反映的是他们的局限，而非你的问题。学会设立边界，保护自己的心理健康。</p>

<h3>四、庆祝真实的自己</h3>
<p>出柜是一次解放，是对真实自我的肯定。无论前路如何，你已经迈出了最勇敢的一步。为自己感到骄傲，庆祝真实的自己。</p>

<h3>五、过来人的心声</h3>
<p>"出柜半年后，我才真正感受到轻松。那段等待的时间很难熬，但现在回头看，每一步都是值得的。" —— 浩然</p>
<p>"最大的改变不是别人怎么看我，而是我怎么看自己。出柜让我学会真正爱自己。" —— 阿哲</p>`,
    category: "self-growth",
    categoryName: "自我成长",
    author: "浩然",
    date: "2026-08-02",
    readTime: "10分钟",
    image: "https://readdy.ai/api/search-image?query=Serene%20sunrise%20over%20calm%20ocean%20horizon%2C%20soft%20pastel%20sky%20colors%20with%20gentle%20clouds%2C%20peaceful%20and%20hopeful%20atmosphere%2C%20minimalist%20nature%20photography%2C%20warm%20golden%20light%20breaking%20through%2C%20symbolizing%20new%20beginnings%2C%20no%20people&width=800&height=500&seq=article-feat-3&orientation=landscape",
    tags: ["自我成长", "心理调适", "出柜", "人生经验"]
  },
  {
    id: 4,
    title: "同志伴侣的相处之道：构建健康的亲密关系",
    excerpt: "健康的亲密关系需要双方的努力和智慧。本文从沟通技巧、冲突处理、未来规划等角度，分享同志伴侣的相处之道。",
    content: `构建健康的亲密关系是每一对伴侣都需要面对的课题。对于同志伴侣而言，除了普遍的关系维护外，还有一些特殊的考量。

<h3>一、有效沟通的核心</h3>
<p>沟通是关系的基石。学会表达自己的感受而非指责对方，学会倾听而非急于反驳，是有效沟通的关键。推荐使用"我感觉……"而非"你总是……"的句式来开启对话。</p>

<h3>二、处理冲突的智慧</h3>
<p>冲突是任何关系中的正常现象。关键在于如何处理。冷静下来再讨论、一次只解决一个问题、寻找双赢的解决方案，这些都是处理冲突的有效方法。</p>

<h3>三、共同面对外部压力</h3>
<p>同志伴侣可能面临来自家庭或社会的额外压力。在这种情况下，相互支持、统一战线尤为重要。提前商量如何应对外界的质疑和压力，可以减少很多不必要的矛盾。</p>

<h3>四、规划你们的未来</h3>
<p>无论是短期的旅行计划还是长期的生活规划，共同的目标能让关系更加牢固。定期坐下来聊聊你们对未来的期待和计划，确保你们在朝着共同的方向前进。</p>`,
    category: "dating-tips",
    categoryName: "交友技巧",
    author: "明哲",
    date: "2026-07-28",
    readTime: "9分钟",
    image: "https://readdy.ai/api/search-image?query=Two%20warm%20coffee%20cups%20on%20a%20wooden%20table%20by%20a%20window%20with%20soft%20morning%20light%2C%20cozy%20cafe%20atmosphere%2C%20intimate%20and%20romantic%20setting%2C%20minimalist%20composition%2C%20warm%20beige%20and%20terracotta%20tones%2C%20editorial%20photography%2C%20no%20people&width=800&height=500&seq=article-4&orientation=landscape",
    tags: ["亲密关系", "沟通技巧", "伴侣", "情感指南"]
  },
  {
    id: 5,
    title: "独居生活指南：打造属于你的舒适小窝",
    excerpt: "一个人也要好好生活。从家居布置到日常习惯，分享打造舒适独居生活的实用建议和灵感。",
    content: `独居是一种生活方式的选择。对许多同志朋友来说，独居意味着更多的自由和自主权。让我们一起探讨如何打造一个舒适、温馨的独居空间。

<h3>一、空间规划的基本原则</h3>
<p>即使空间有限，合理的规划也能让居住体验大幅提升。分区管理是关键：工作区、休息区、娱乐区各司其职。灵活使用收纳工具，保持空间整洁有序。</p>

<h3>二、营造温馨氛围</h3>
<p>灯光、绿植和香氛是营造居家氛围的三大法宝。选择暖色调的灯具，摆放几盆好养的绿植，点一支喜欢的香薰蜡烛，让回家成为一天中最期待的事。</p>

<h3>三、培养健康的生活习惯</h3>
<p>独居需要更强的自律能力。建立规律的作息时间，坚持适量的运动，为自己烹饪健康的餐食。这些习惯不仅有益健康，也能带来生活的掌控感和成就感。</p>

<h3>四、丰富精神生活</h3>
<p>阅读、音乐、电影、手作——培养一两项可以独自享受的爱好，让独处时光变得充实而有趣。也可以在男同网上和同好交流，分享生活的点滴。</p>`,
    category: "life-share",
    categoryName: "生活分享",
    author: "子轩",
    date: "2026-07-22",
    readTime: "7分钟",
    image: "https://readdy.ai/api/search-image?query=Cozy%20minimalist%20apartment%20interior%20with%20warm%20lighting%2C%20plants%20on%20shelves%2C%20comfortable%20sofa%20with%20textured%20throws%2C%20books%20and%20art%20on%20walls%2C%20soft%20evening%20ambiance%2C%20Scandinavian%20inspired%20design%2C%20warm%20neutral%20tones%2C%20no%20people&width=800&height=500&seq=article-5&orientation=landscape",
    tags: ["生活分享", "独居", "家居", "生活方式"]
  },
  {
    id: 6,
    title: "提升自信的五种日常练习方法",
    excerpt: "自信是可以后天培养的。本文分享五种简单有效的日常练习方法，帮助你在社交和生活中更加从容自信。",
    content: `自信不是与生俱来的天赋，而是可以通过日常练习逐步培养的能力。以下是五种简单有效的练习方法。

<h3>一、积极的自我对话</h3>
<p>我们每天都在和自己对话。留意你对自己说的话，把"我不行"换成"我可以试试"，把"我不够好"换成"我在进步"。积极的自我对话能逐渐改变你的自我认知。</p>

<h3>二、身体语言的调整</h3>
<p>身体语言不仅影响别人对你的看法，更影响你对自己的感觉。挺直腰背、抬头挺胸、保持微笑——这些简单的动作能立刻提升你的自信水平。</p>

<h3>三、设定并完成小目标</h3>
<p>从小事开始，每天设定一两个可以完成的小目标。每完成一个目标，都是对自我效能感的一次正向强化。日积月累，你会发现自己能做的事情越来越多。</p>

<h3>四、走出舒适区</h3>
<p>舒适区之外是成长区。每周尝试一件让你略感紧张但又不至于恐慌的事情，比如在男同网上主动发起一次话题讨论，或参加一次线下社群活动。</p>

<h3>五、感恩练习</h3>
<p>每天睡前写下三件让你感恩的事情，无论大小。这个练习能帮助你关注生活中的积极面，减少负面比较，建立更加稳定的自我价值感。</p>`,
    category: "self-growth",
    categoryName: "自我成长",
    author: "浩然",
    date: "2026-07-18",
    readTime: "6分钟",
    image: "https://readdy.ai/api/search-image?query=Person%20standing%20in%20front%20of%20a%20large%20window%20with%20sunlight%20streaming%20in%2C%20confident%20posture%2C%20modern%20loft%20interior%2C%20inspirational%20atmosphere%2C%20warm%20golden%20hour%20lighting%2C%20minimalist%20design%2C%20low%20contrast%20dreamy%20mood&width=800&height=500&seq=article-6&orientation=landscape",
    tags: ["自我成长", "自信心", "心理建设", "日常练习"]
  },
  {
    id: 7,
    title: "健身入门指南：制定属于你的训练计划",
    excerpt: "健身不只是为了好身材，更是对自己健康的投资。这份入门指南帮你从零开始，制定适合自己的训练计划。",
    content: `健身是提升生活品质的重要方式。无论你是为了健康、塑形还是减压，这份入门指南都能帮你迈出第一步。

<h3>一、明确你的健身目标</h3>
<p>不同的目标需要不同的训练方式。是想增肌、减脂、提高体能还是改善体态？明确目标能帮助你选择最适合的训练方法和制定合理的预期。</p>

<h3>二、初学者的训练原则</h3>
<p>循序渐进是最重要的原则。从每周2-3次、每次30-45分钟开始。重点掌握动作的正确姿势，而不是追求重量和数量。可以请专业教练指导，或通过可靠的视频教程学习。</p>

<h3>三、饮食的重要性</h3>
<p>训练效果三分靠练、七分靠吃。保证充足的蛋白质摄入，控制精制碳水和加工食品的摄入，多喝水，保证充足的睡眠。这些都是健身成功的关键因素。</p>

<h3>四、保持动力的小技巧</h3>
<p>找到你真正喜欢的运动方式，约上朋友一起训练，记录你的进步，适时犒劳自己。在男同网的运动健身群组中，你能找到志同道合的伙伴，互相鼓励和监督。</p>`,
    category: "health-wellness",
    categoryName: "健康养生",
    author: "翔宇",
    date: "2026-07-15",
    readTime: "8分钟",
    image: "https://readdy.ai/api/search-image?query=Clean%20modern%20gym%20interior%20with%20natural%20lighting%2C%20minimalist%20fitness%20equipment%2C%20wooden%20flooring%2C%20indoor%20plants%2C%20calm%20and%20motivating%20atmosphere%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20no%20people&width=800&height=500&seq=article-7&orientation=landscape",
    tags: ["健康养生", "健身", "运动", "生活方式"]
  },
  {
    id: 8,
    title: "从《以你的心诠释我的爱》看泰国BL剧的文化影响",
    excerpt: "泰国BL剧近年来在亚洲乃至全球掀起热潮。本文以经典作品为例，探讨BL文化对同志社群认同和大众认知的影响。",
    content: `近年来，以泰国为首的BL（Boys' Love）剧集在全球范围内获得了巨大的关注。这些作品不仅是娱乐，更在潜移默化中改变了人们对同志群体的认知。

<h3>一、BL剧的叙事特点</h3>
<p>与传统同志题材影视作品不同，BL剧往往更注重情感的表达和浪漫的情节。它们创造了一个相对理想化的世界，在这个世界里，同性之爱被自然地接纳和赞美。</p>

<h3>二、对同志社群的积极影响</h3>
<p>BL剧为同志群体提供了情感认同的媒介。看到屏幕上的角色经历相似的挣扎和甜蜜，许多同志观众感受到了前所未有的共鸣和慰藉。同时，这些作品也让更多人开始关注和理解同志群体。</p>

<h3>三、文化输出的新维度</h3>
<p>泰国BL剧的成功，展示了文化输出的新可能。它们不仅创造了经济价值，更传递了关于爱与包容的普世价值观。男同网也定期组织相关剧集的讨论和观影活动。</p>

<h3>四、理性看待与现实的距离</h3>
<p>虽然BL剧带来了诸多积极影响，但我们也需要认识到荧幕与现实的区别。真实的同志生活远比剧集复杂，建立健康的感情观比迷恋荧幕CP更为重要。</p>`,
    category: "culture-entertainment",
    categoryName: "文化娱乐",
    author: "小哲",
    date: "2026-07-10",
    readTime: "11分钟",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20scene%20with%20warm%20vintage%20film%20aesthetic%2C%20movie%20projector%20casting%20soft%20light%2C%20retro%20theater%20atmosphere%2C%20nostalgic%20and%20romantic%20mood%2C%20warm%20golden%20and%20amber%20tones%2C%20artistic%20composition%2C%20film%20noir%20inspired%20lighting&width=800&height=500&seq=article-8&orientation=landscape",
    tags: ["文化娱乐", "影视", "BL剧", "文化观察"]
  },
  {
    id: 9,
    title: "同志友好的旅行目的地推荐（国内篇）",
    excerpt: "精心挑选了国内五个同志友好氛围浓厚的旅行目的地，从繁华都市到静谧古城，总有一处适合你的下一趟旅程。",
    content: `旅行是心灵的自由。对于同志群体来说，选择一个友好包容的目的地能让旅途更加轻松愉快。以下是国内五个值得推荐的旅行目的地。

<h3>一、成都 — 包容之都</h3>
<p>成都以其包容开放的城市文化闻名。这里不仅有丰富的美食和悠闲的生活节奏，更有活跃的同志社群和众多同志友好场所。太古里、九眼桥一带的夜生活丰富多彩。</p>

<h3>二、上海 — 国际都会</h3>
<p>作为国际化大都市，上海的同志文化底蕴深厚。法租界的梧桐树下、外滩的江风中，你能感受到这座城市独特的魅力。每年举办的上海骄傲节活动丰富多元。</p>

<h3>三、大理 — 世外桃源</h3>
<p>洱海边的古城、苍山上的云海，大理是许多同志朋友心中的乌托邦。这里的生活节奏缓慢而舒适，许多民宿和咖啡馆对同志群体格外友好。</p>

<h3>四、厦门 — 海岛浪漫</h3>
<p>鼓浪屿的琴声、环岛路的日落、沙坡尾的文艺小店——厦门的每一个角落都散发着浪漫气息。这座城市对多元文化的包容让每一位旅行者感到自在。</p>

<h3>五、杭州 — 诗意栖居</h3>
<p>西湖的柔美、灵隐的禅意、龙井的茶香——杭州是充满诗意的旅行目的地。这里的同志社群友善而活跃，定期举办各种聚会活动。</p>`,
    category: "life-share",
    categoryName: "生活分享",
    author: "子轩",
    date: "2026-07-05",
    readTime: "9分钟",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20ancient%20town%20with%20traditional%20architecture%2C%20soft%20sunset%20lighting%2C%20river%20reflection%2C%20lush%20greenery%2C%20peaceful%20travel%20atmosphere%2C%20warm%20golden%20hour%20tones%2C%20romantic%20and%20serene%20composition%2C%20editorial%20travel%20photography&width=800&height=500&seq=article-9&orientation=landscape",
    tags: ["生活分享", "旅行", "目的地推荐", "生活方式"]
  },
  {
    id: 10,
    title: "压力管理与心理健康：关注你的情绪健康",
    excerpt: "在快节奏的现代生活中，学会管理压力和维护心理健康越发重要。本文分享实用的压力管理技巧和日常心理维护方法。",
    content: `关注心理健康就是关爱自己。在这个压力无处不在的时代，学会管理情绪、维护心理健康，是每个人都需要掌握的生活技能。

<h3>一、识别压力信号</h3>
<p>身体是最诚实的信号塔。持续的疲劳感、失眠或嗜睡、食欲改变、易怒或情绪低落，都可能是压力过大的表现。学会聆听身体的信号，在问题恶化之前及时调整。</p>

<h3>二、实用的减压方法</h3>
<p>深呼吸练习是随时随地可以使用的减压工具。4-7-8呼吸法（吸气4秒、屏息7秒、呼气8秒）能够快速激活副交感神经系统，帮助身心放松。此外，正念冥想、运动出汗、与好友倾诉，都是经过验证的有效减压方式。</p>

<h3>三、建立健康的生活方式</h3>
<p>规律的作息、均衡的饮食、适度的运动，是心理健康的三大基石。同时，合理使用社交媒体，避免信息过载，为大脑留出休息和放空的时间。</p>

<h3>四、何时寻求专业帮助</h3>
<p>当负面情绪持续超过两周，或者已经明显影响到日常生活和工作时，建议寻求专业心理咨询师的帮助。求助不是软弱的表现，而是关爱自己的勇敢行为。</p>`,
    category: "health-wellness",
    categoryName: "健康养生",
    author: "翔宇",
    date: "2026-06-28",
    readTime: "7分钟",
    image: "https://readdy.ai/api/search-image?query=Peaceful%20zen%20garden%20with%20smooth%20sand%20patterns%20and%20stones%2C%20soft%20morning%20light%2C%20mindfulness%20and%20meditation%20atmosphere%2C%20minimalist%20Japanese%20aesthetic%2C%20calm%20and%20healing%20mood%2C%20warm%20neutral%20tones%2C%20no%20people&width=800&height=500&seq=article-10&orientation=landscape",
    tags: ["健康养生", "心理健康", "压力管理", "自我关爱"]
  }
];

export const categoryArticlesMap: Record<string, ArticleItem[]> = {};
allArticles.forEach(article => {
  if (!categoryArticlesMap[article.category]) {
    categoryArticlesMap[article.category] = [];
  }
  categoryArticlesMap[article.category].push(article);
});